<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <div class="checkbox">
      <input class="show-for-sr" type="checkbox" id="useNAD" [(ngModel)]="componentData.config.useNAD" />
      <label for="useNAD">
        <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Treat Latitude / Longitude as NAD83 X/Y Values
      </label>
    </div>
  </div>
  <div class="cell small-12">
    <div class="checkbox">
      <input class="show-for-sr" type="checkbox" id="enforcePosition" [(ngModel)]="componentData.config.enforcePositionRequirement" />
      <label for="enforcePosition">
        <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Require String Positions
      </label>
    </div>
  </div>
</div>
<accordion>
  <accordion-panel>
    <div panel-header>Context Locations for Well Data from earlier in the flow (One answer possible per flow)</div>
    @for (opt of singleEntryOptions; track opt) {
      <div class="grid-x">
        <div class="cell small-5 small-font-size">
          {{opt.displayName}} :
        </div>
        <div class="cell small-7">
          <input type="text" [id]="opt.displayName" [(ngModel)]="opt.location" />
        </div>
      </div>
    }
  </accordion-panel>
  <accordion-panel>
    <div panel-header>Context Locations for Well Data from earlier in the flow (More than one answer possible per flow)</div>
    @for (opt of multipleEntryOptions; track opt) {
      @for (entry of opt.multipleLocations; track entry; let i = $index) {
        <div class="grid-x">
          <div class="cell small-5 small-font-size">
            {{opt.displayName}} [{{i}}] @if (i === opt.multipleLocations.length - 1) {
            <button (click)="addEntry(opt)"><svg-icon icon="icon-plus" class="small"></svg-icon></button>
          }
        </div>
        <div class="cell small-7 small-font-size">
          <input type="text" [id]="opt.displayName + '_' + i" [(ngModel)]="opt.multipleLocations[i]" />
        </div>
      </div>
    }
  }
</accordion-panel>
</accordion>
